<div class="grid-container">
  <h2>SurveyJS Library - a sample survey below</h2>
  <survey-component [json]="json" [config]="config" [data]="data" (submitSurvey)="sendData($event)"></survey-component>
</div>
